// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICommunicationStatusDto
 */
export interface ICommunicationStatusDto {
    /**
     * 
     * @type {Date}
     * @memberof ICommunicationStatusDto
     */
    datetime?: Date;
    /**
     * 
     * @type {string}
     * @memberof ICommunicationStatusDto
     */
    notification_status?: ICommunicationStatusDtoNotificationStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum ICommunicationStatusDtoNotificationStatusEnum {
    NOT_SENT = 'NOT_SENT',
    SENT = 'SENT',
    CANCELLED = 'CANCELLED',
    ARCHIVED = 'ARCHIVED',
    READ = 'READ',
    RESENT = 'RESENT',
    SENDING = 'SENDING',
    BOUNCED = 'BOUNCED',
    DELIVERED = 'DELIVERED',
    OPENED = 'OPENED',
    REPORTED_AS_SPAM = 'REPORTED_AS_SPAM',
    UNSUBSCRIBED = 'UNSUBSCRIBED',
    RETURNED = 'RETURNED',
    PENDING_ADDRESS = 'PENDING_ADDRESS'
}


/**
 * Check if a given object implements the ICommunicationStatusDto interface.
 */
export function instanceOfICommunicationStatusDto(value: object): value is ICommunicationStatusDto {
    return true;
}

export function ICommunicationStatusDtoFromJSON(json: any): ICommunicationStatusDto {
    return ICommunicationStatusDtoFromJSONTyped(json, false);
}

export function ICommunicationStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICommunicationStatusDto {
    if (json == null) {
        return json;
    }
    return {
        
        'datetime': json['datetime'] == null ? undefined : (new Date(json['datetime'])),
        'notification_status': json['notification_status'] == null ? undefined : json['notification_status'],
    };
}

export function ICommunicationStatusDtoToJSON(json: any): ICommunicationStatusDto {
    return ICommunicationStatusDtoToJSONTyped(json, false);
}

export function ICommunicationStatusDtoToJSONTyped(value?: ICommunicationStatusDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'datetime': value['datetime'] == null ? undefined : ((value['datetime']).toISOString()),
        'notification_status': value['notification_status'],
    };
}

